var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chevron",class:{ 'chevron--open': _vm.is_open },style:({ '--rotation': `${_vm.rotation}deg` })},[_c('vb-icon',{attrs:{"name":_vm.icon,"size":_vm.size,"color":_vm.color}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }